import { Form, Theme, Viewport } from '@livecontrol/core-ui';
import { Modal } from '@livecontrol/scheduler/components';
import _ from 'lodash';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useDefcon } from './graphql';

export const DefconCommand = ({
  command,
  webplayerClientId,
  title = 'Are your sure you want to refresh the stream?',
  content = 'This action will take up to 30 seconds to complete',
  tooltip,
  cta,
  variant = 'outline-light'
}: {
  command: Parameters<typeof useDefcon>[0];
  webplayerClientId?: string;
  tooltip?: string;
  title?: string;
  content?: string;
  cta?: string;
  variant?: string;
}): React.ReactElement => {
  const viewport = Theme.useViewport();
  const prompt = Modal.usePrompt();

  const [mutate, { loading }] = useDefcon(command);

  return (
    <OverlayTrigger
      placement='bottom'
      overlay={<Tooltip id={_.uniqueId('tooltip')}>{tooltip}</Tooltip>}
    >
      <Form
        onSubmit={(e): void => {
          e.preventDefault();
        }}
      >
        <Form.Submit
          size={viewport === Viewport.XL ? 'md' : 'sm'}
          className='w-100'
          loading={loading}
          variant={variant}
          onClick={(): void => {
            prompt.confirm({
              title,
              content,
              onAnswer(answer) {
                if (answer && webplayerClientId) {
                  void mutate(webplayerClientId);
                }
              }
            });
          }}
        >
          {cta}
        </Form.Submit>
      </Form>
    </OverlayTrigger>
  );
};
